// extracted by mini-css-extract-plugin
export default {"rangeButton":"date-range-button_rangeButton__2GHEo","customIcon":"date-range-button_customIcon__M5Rhs","label":"date-range-button_label__1+MwY"};